import React, {Component} from 'react';
import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';
import {isJson} from "../functions/functions";

class ConnectedDevices extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_ws_connection_details&only_json', (component, data) => {
                    console.log('data...', data);
                    // if (!isJson(data)) {

                    if (typeof data === 'string') {
                        return;
                    }

                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                    // }
                });
            }, 1000)
        };
    }


    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    generateTableRows() {
        {
            if (!this.state.redis_data) {
                return (null);
            }

            // let data = JSON.parse(this.state.redis_data);

            // console.log(data);

            return Object.entries(this.state.redis_data).map((value, i) => {
                let k = value[0];
                let v = value[1];

                let connected_for = parseFloat(new Date().getTime() / 1000 + -v['connect_time']).toFixed(2);

                return (
                    <tr key={k}>
                        <td>{k}</td>
                        <td>{v['connect_time']}</td>
                        <td>{v['last_time']}</td>
                        <td>{v['remote_ip']}</td>
                        <td>{v['remote_port']}</td>
                        <td>{v['server_fd']}</td>
                        <td>{connected_for} s</td>
                    </tr>
                );
            });
        }
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }

    render() {
        if (!this.state.redis_data) return this.noDataPreloader();
        // console.log('rendering...');

        return (
            <table className="table">
                <thead>
                <tr>
                    <th scope="col">Conn ID</th>
                    <th scope="col">Conn Time</th>
                    <th scope="col">Last Time</th>
                    <th scope="col">Remote IP</th>
                    <th scope="col">Remote PORT</th>
                    <th scope="col">Server FD</th>
                    <th scope="col">Conn For</th>
                </tr>
                </thead>
                <tbody>
                {this.generateTableRows()}
                </tbody>
            </table>
        );
    }
}

export default ConnectedDevices;



// WEBPACK FOOTER //
// ./src/components/ConnectedDevices.js